(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('VehiclesFormController', VehiclesFormController);
    

    VehiclesFormController.$inject = [
		'$stateParams',
		'vehicleService',
		'genericDataService',
		'$filter',
		'$state',
		'$rootScope',
		'notificationService',
		'preferences', 
		'restrictionService'
    ];

	function VehiclesFormController($stateParams, vehicleService, genericDataService, $filter,
		 $state, $rootScope, notificationService, preferences, restrictionService) {
		/* PRIVATE VARIABLES */
		var id = $stateParams.id;

		/* PUBLIC VARIABLES */

		var vm = this;
		vm.stateParams = $stateParams;
		vm.flota = {
			vehiculo : {},
			localizador : {}
		};
		vm.edit = false;
		vm.textInput = '';
		vm.genericData = {
			tiposFlota: {
				list: null,
				selected: { id: null }
			},
			tiposSubFlota: {
				fullList: null,
				list: null,
				selected: { id: null }
			},
			grupos: {
				list: null,
				selected: { id: null }
			},
			estados: {
				list: [
					{ nombre: 'Libre', id: 0 },
					{ nombre: 'Ocupado', id: 1 },
					{ nombre: 'Baja', id: 3 },
					{ nombre: 'Inactivo', id: 4 }
					],
				selected: { id: null }
			},
			dispositivoLocalizador: {
				list: [
					{ nombre: 'GPS embarcado en vehículo', id: 'LOC'  },
					{ nombre: 'GPS integrado del terminal de datos (PDA)', id: 'PDA' },
					{ nombre: 'Sin localización GPS', id: 'NOL' },
				],
				selected: { id: null }
			},
			identificacionOperaro: {
				list: [
					{ nombre: 'Sin identificación del operario', id: 0 },
					{ nombre: 'Por terminal de datos (PDA)', id: 1 },
					{ nombre: 'Por dispositivo identificador', id: 2 },
				],
				selected: { id: null }
			},
			empresas: {
				list: null,
				selected: { id: null }
			}
		};
		vm.dates = {
			caducidad: null,
			baja: null,
		};

		vm.preferences = preferences;

		vm.save = save;
		vm.saveAndClose = saveAndClose;
		vm.saveAndNew = saveAndNew;
		vm.onTipoFlotaChange = onTipoFlotaChange;
		vm.onTipoSubFlotaChange = onTipoSubFlotaChange;
        vm.effectClass = effectClass;
		vm.resizable = resizable;
        vm.showEditIcon = showEditIcon;
        vm.hideEditIcon = hideEditIcon;
        vm.showEditIconValue = false;

		vm.accionSaveList = [
			{
				accionTexto: 'Guardar y cerrar',
				accion: vm.saveAndClose,
				selected: computeValueAccionSelected('guardarCerrar')
			},
			{
				accionTexto: 'Guardar y nuevo',
				accion: vm.saveAndNew,
				selected: computeValueAccionSelected('saveAndNew')
			},
			{
				accionTexto: 'Guardar',
				accion: vm.save,
				selected: computeValueAccionSelected('save')
			},
		];

		(function () {

			//Edit
			if (id != null) {
				vm.edit = true;
				vehicleService.getFlota(id)
                    .then(function (flota) {
						vm.flota = flota;
						getGenericData();
						setDates();
					});

			}
			//New
			else {
				getGenericData();
			}
		})();

		/* PRIVATE FUNCTIONS */
		function getGenericData() {
			vm.genericData.tiposFlota.loading = true;
			genericDataService.getTiposFlota()
                .then(function (res) {
					vm.genericData.tiposFlota.loading = false;
					vm.genericData.tiposFlota.list = res;
					var modelTiposFlota = findByProperty(vm.genericData.tiposFlota.list, 'id', vm.flota.tipoFlotaId);
					if (modelTiposFlota) {
						vm.genericData.tiposFlota.selected = modelTiposFlota;
					}
					else {
						vm.genericData.tiposFlota.selected = vm.genericData.tiposFlota.list[0];
					}
				});

			vm.genericData.tiposSubFlota.loading = true;
			genericDataService.getTiposSubFlota()
				.then(function (res) {
					vm.genericData.tiposSubFlota.loading = false;
					vm.genericData.tiposSubFlota.list = res;
					vm.genericData.tiposSubFlota.fullList = res;
					var modelTiposSubFlota = findByProperty(vm.genericData.tiposSubFlota.list,
						'id', vm.flota.tipoSubFlotaId);
					if (modelTiposSubFlota) {
						vm.genericData.tiposSubFlota.selected = modelTiposSubFlota;
					}
					else {
						vm.genericData.tiposSubFlota.selected = vm.genericData.tiposSubFlota.list[0];
					}
				});
			genericDataService.getGrupos()
				.then(function (res) {
					vm.genericData.grupos.loading = false;
					vm.genericData.grupos.list = res;
					var modelGrupos = findByProperty(vm.genericData.grupos.list, 'id', vm.flota.grupoId);
					if (modelGrupos) {
						vm.genericData.grupos.selected = modelGrupos;
					}
					else {
						vm.genericData.grupos.selected = vm.genericData.grupos.list[0];
					}
				});
			vm.genericData.empresas.loading = true;
			genericDataService.getEmpresas()
				.then(function (res) {
					vm.genericData.empresas.loading = false;
					vm.genericData.empresas.list = res;
					var modelEmpresas = findByProperty(vm.genericData.empresas.list, 'id', vm.flota.empresaId);
					if (modelEmpresas) {
						vm.genericData.empresas.selected = modelEmpresas;
					}
					else {
						vm.genericData.empresas.selected = vm.genericData.empresas.list[0];
					}
				});
			if (vm.flota.estado !== undefined && vm.flota.estado !== null) {
				vm.genericData.estados.selected = {
					id: vm.flota.estado,
					nombre: getEstadoVehiculoDescripcion(vm.flota.estado)
				};
			}
			else {
				vm.genericData.estados.selected = vm.genericData.estados.list[0];
			}
			if (vm.flota.localizador !== undefined && vm.flota.localizador.tipo !== null &&
				vm.flota.localizador.tipo !== undefined) {
				vm.genericData.dispositivoLocalizador.selected = {
					id: vm.flota.localizador.tipo,
					nombre: getDispositivoLocalizadorVehiculoDescripcion(vm.flota.localizador.tipo)
				};
			}
			else {
				vm.genericData.dispositivoLocalizador.selected = vm.genericData.dispositivoLocalizador.list[0];
			}

			if (vm.flota.identificacionId !== undefined && vm.flota.identificacionId !== null) {
				vm.genericData.identificacionOperaro.selected = {
					id: vm.flota.identificacionId,
					nombre: getIdentificacionOperariosVehiculoDescripcion(vm.flota.identificacionId)
				};
			}
			else {
				vm.genericData.identificacionOperaro.selected = vm.genericData.identificacionOperaro.list[0];
			}
			
		}

		function onTipoFlotaChange() {
            var tf = vm.genericData.tiposFlota.selected && vm.genericData.tiposFlota.selected.id;
            if(tf){
                vm.genericData.tiposSubFlota.list = $filter('filter')
                    (vm.genericData.tiposSubFlota.fullList, {tipoFlotaId:tf}, true);
                selectChanged(vm.genericData.tiposSubFlota.list, vm.genericData.tiposSubFlota);
            }else{
                vm.genericData.tiposSubFlota.list = vm.genericData.tiposSubFlota.fullList;
                selectChanged(vm.genericData.tiposSubFlota.list, vm.genericData.tiposSubFlota);
            }
        }
        function onTipoSubFlotaChange(){
            var tsf  = findByProperty(vm.genericData.tiposSubFlota.list, 'id', 
                vm.genericData.tiposSubFlota.selected.id);
            if(tsf){
                var tf = { id: tsf.tipoFlotaId };
                if(vm.genericData.tiposFlota.list){
                    tf = findByProperty(vm.genericData.tiposFlota.list, 'id', tsf.tipoFlotaId);
                }
                vm.genericData.tiposFlota.selected = tf;
            }
        }

        function setDates() {
            vm.dates.caducidad = vm.flota.vehiculo.fcadlicencia && new Date(vm.flota.vehiculo.fcadlicencia);
			vm.dates.baja = vm.flota.fechabaja && new Date(vm.flota.fechabaja);
		}

		function findByProperty(array, property, id) {
			if (array === null) { return null; }
			for (var i = 0; i < array.length; i++) {
				if (array[i][property] === id) {
					return array[i];
				}
			}
			return null;
		}

		function getEstadoVehiculoDescripcion(estado) {
			if (estado === 0) {
				return 'Libre';
			} else if (estado === 1) {
				return 'Ocupado';
			} else if (estado === 3) {
				return 'Baja';
			} else if (estado === 4 || estado === 2) {
				return 'Inactivo';
			} 
		}

		function getIdentificacionOperariosVehiculoDescripcion(idenOperario) {
			if (idenOperario === 0) {
				return 'Sin identificación del operario';
			} else if (idenOperario === 1) {
				return 'Por terminal de datos (PDA)';
			} else if (idenOperario === 2) {
				return 'Por dispositivo identificador';
			}
		}

		function getDispositivoLocalizadorVehiculoDescripcion(dispLocalizador) {
			if (dispLocalizador === 'LOC') {
				return 'GPS embarcado en vehículo';
			} else if (dispLocalizador === 'PDA') {
				return 'GPS integrado del terminal de datos (PDA)';
			} else if (dispLocalizador === 'NOL') {
				return 'Sin localización GPS';
			}
		}

		function computeValueAccionSelected(accion) {
			if (accion === vm.stateParams.accion) { return true; }
			return false;
		}

		function doSave(action) {
			if(vm.edit == true) {
				if (!restrictionService.hasPermission(4, 'flota')) return;
			}
			else {
				if (!restrictionService.hasPermission(1, 'flota')) return;
			}
			if (vm.edit && (vm.flota.id === null || vm.flota.id === '' || vm.flota.id === undefined)) { 
				sendErrorRequire();
			    return;
			}
			vm.flota.tipoFlotaId = vm.genericData.tiposFlota.selected.id;
			vm.flota.tipoSubFlotaId = vm.genericData.tiposSubFlota.selected.id;
			vm.flota.grupoId = vm.genericData.grupos.selected.id;
			vm.flota.estado = vm.genericData.estados.selected.id;
			vm.flota.identificacionId = vm.genericData.identificacionOperaro.selected.id;
			vm.flota.empresaId = vm.genericData.empresas.selected.id;

			vm.flota.vehiculo.fcadlicencia = vm.dates.caducidad;
			vm.flota.fechabaja = vm.dates.baja;


			if (vm.flota.localizador !== null) {
				vm.flota.localizador.tipo = vm.genericData.dispositivoLocalizador.selected.id;
			}
			//CREAR LOCALIZADOR SI ES NUEVO O BIEN NO LO TIENE
			vehicleService.addVehicle(vm.flota).then(function (flotaSave) {
				sendSAveNotification();
				vm.edit = true;
				if (action === 'saveAndClose') {
					$state.go('flota.vehiculos.listado');
				}
				else if (action === 'saveAndNew') {
					$state.go('flota.vehiculos.nuevo', { 'accion': 'saveAndNew' });
				}
				else {
					vm.flota.id = flotaSave.id;
					vm.flota.flotaId = flotaSave.flotaId;
				}
			});
		}

		function save() {
			var action = 'save';
			for (var i = 0; i < vm.accionSaveList.length; ++i) {
				if (vm.accionSaveList[i].accionTexto === 'Guardar') { vm.accionSaveList[i].selected = true; }
				else { vm.accionSaveList[i].selected = false; }
			}
			doSave(action);
		}

		function saveAndClose() {
			var action = 'saveAndClose';
			doSave(action);
		}

		function saveAndNew() {
			for (var i = 0; i < vm.accionSaveList.length; ++i) {
				if (vm.accionSaveList[i].accionTexto === 'Guardar y nuevo') { vm.accionSaveList[i].selected = true; }
				else { vm.accionSaveList[i].selected = false; }
			}
			var action = 'saveAndNew';
			doSave(action);
		}

		function sendSAveNotification() {
			notificationService.sendAppNotification({
				message: 'El vehículo se ha guardado correctamente',
				positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
			});
		}

		function sendErrorRequire() {
			notificationService.sendAppNotification({
				message: 'El campo Id es obligatorio',
				positionY: 'top', positionX: 'right', delay: 3000, type: 'error'
			});
			
		}

		// Try to find the selected element in the list using the id property
        // If requireId is false it will keep the name even when id is null
        function selectChanged(list, obj, requireId) {
			var selected = obj.selected;
            requireId = (typeof requireId === 'undefined') ? true : requireId; //RequireId defaults to TRUE
            if (!list || !selected) { return; } //If the is no list or element exit
            if (list.length <= 0 || selected.id == null) { // Delete element unless it doesnt require id
				if (!requireId) { return; }
				obj.selected = {nombre:null, id:null };
                return;
            }
            var find = findByProperty(list, 'id', selected.id);
            if (find) {
                Object.assign(selected, find);
            } else {
				obj.selected = {nombre:null, id:null };
            }
		}

		function effectClass(target) {
			vm.effects = {};
			vm.effects[target] = true;
			setTimeout(function () {
				vm.effects[target] = undefined;
			}, 3000);
		}

		function resizableInput(el, factor) {
			var int = Number(factor) || 7.7;
			function resize() { el.style.width = 'auto'; }
			var e = 'keyup,keypress,focus,blur,change'.split(',');
			for (var i in e) { el.addEventListener(e[i], resize, false); }
			resize();
		}

		function resizable() {
			resizableInput(document.getElementById('txt'), 7);
		}

        function showEditIcon(e) {
            vm.showEditIconValue = true;
        }

        function hideEditIcon(e) {
            if(!$(e.currentTarget).is(":focus"))
                vm.showEditIconValue = false;
        }

    }

})();
